import { ref } from 'vue';
import type { FacilityGroupID, FacilityID, TenantID, UserID } from '../cross-app-shared/types/db.ts';
import type { Email, Uid } from '../cross-app-shared/types/common';
import type { WorkerAvatarLook } from '../cross-app-shared/types/worker-avatar.ts';
import { type EmissionsMassUnitID, emissionsMassUnitDefault } from '../cross-app-shared/types/emissions-mass-units.ts';
import { crossAppActions } from './cross-app-actions.ts';

export const you = ref<{
  userID: UserID;
  firebaseUid: Uid;
  name: string;
  email: string;
  primaryTenantID: TenantID | null;
  primaryFacilityGroupID: FacilityGroupID | null;
  primaryFacilityID: FacilityID | null;
  avatar: WorkerAvatarLook | null;
  emissionsMassUnit: EmissionsMassUnitID;
  isSuperAdmin: boolean;
}>({
  userID: -1 as UserID,
  firebaseUid: 'INVALID UID' as Uid,
  name: 'Unknown User',
  email: 'unknown@example.com' as Email,
  primaryTenantID: null,
  primaryFacilityGroupID: null,
  primaryFacilityID: null,
  avatar: null,
  emissionsMassUnit: emissionsMassUnitDefault,
  isSuperAdmin: false,
});

export async function youRefresh() {
  return await crossAppActions.users
    .you()
    .catch(() => ({
      userID: -1 as UserID,
      firebaseUid: 'INVALID UID' as Uid,
      name: 'Unknown User',
      email: 'unknown@example.com' as Email,
      primaryTenantID: null,
      primaryFacilityGroupID: null,
      primaryFacilityID: null,
      avatar: null,
      emissionsMassUnit: emissionsMassUnitDefault,
      isSuperAdmin: false,
    }))
    .then((response) => {
      you.value = response;
      return response;
    });
}
